module.exports = __webpack_public_path__ + "img/newtaiyo2.b9714c3a.png";